// app/javascript/application.js
//
// Controllers used on every page (layout, header, footer) are in this bundle. The rest load only
// on pages that use them: esbuild splits each into its own file (--splitting), fetched when an
// element with its data-controller is on the page, so the home page doesn't download the practice
// or interview code. The chunks are named *.digested.js, so Propshaft serves them as they are.
import { Application } from "@hotwired/stimulus"
import DarkModeController from "./controllers/dark_mode_controller"
import BackToTopController from "./controllers/back_to_top_controller"
import DropdownController from "./controllers/dropdown_controller"
import FlashMessageController from "./controllers/flash_message_controller"
import MobileMenuController from "./controllers/mobile_menu_controller"
import PracticeDropdownController from "./controllers/practice_dropdown_controller"
import NotificationController from "./controllers/notification_controller"
import VisitTrackerController from "./controllers/visit_tracker_controller"

const application = Application.start()
application.register("dark-mode", DarkModeController)
application.register("back-to-top", BackToTopController)
application.register("dropdown", DropdownController)
application.register("flash-message", FlashMessageController)
application.register("mobile-menu", MobileMenuController)
application.register("practice-dropdown", PracticeDropdownController)
application.register("notification", NotificationController)
application.register("visit-tracker", VisitTrackerController)

const lazyControllers = {
  "accordion": () => import("./controllers/accordion_controller"),
  "auto-save": () => import("./controllers/auto_save_controller"),
  "faq-filter": () => import("./controllers/faq_filter_controller"),
  "faq-search": () => import("./controllers/faq_search_controller"),
  "iq-hero": () => import("./controllers/iq_hero_controller"),
  "lp-sample": () => import("./controllers/lp_sample_controller"),
  "lp-steps": () => import("./controllers/lp_steps_controller"),
  "lp-count": () => import("./controllers/lp_count_controller"),
  "lp-marquee": () => import("./controllers/lp_marquee_controller"),
  "lp-answer": () => import("./controllers/lp_answer_controller"),
  "lp-reveal": () => import("./controllers/lp_reveal_controller"),
  "report-mistake": () => import("./controllers/report_mistake_controller"),
  "iq-search": () => import("./controllers/iq_search_controller"),
  "iq-subject": () => import("./controllers/iq_subject_controller"),
  "iq-plan": () => import("./controllers/iq_plan_controller"),
  "iq-plan-live": () => import("./controllers/iq_plan_live_controller"),
  "practice-questions": () => import("./controllers/practice_questions_controller"),
  "progress": () => import("./controllers/progress_controller"),
  "submenu": () => import("./controllers/submenu_controller"),
}

function loadControllersIn(root) {
  if (!root.querySelectorAll) return
  const elements = root.matches?.("[data-controller]") ? [root, ...root.querySelectorAll("[data-controller]")] : root.querySelectorAll("[data-controller]")
  elements.forEach(element => {
    element.getAttribute("data-controller").split(/\s+/).forEach(identifier => {
      const load = lazyControllers[identifier]
      if (!load) return
      delete lazyControllers[identifier] // load each once
      load().then(module => application.register(identifier, module.default))
    })
  })
}

// Now, and for markup added later (fetched menus, "Load more" questions)
loadControllersIn(document)
new MutationObserver(mutations => {
  if (Object.keys(lazyControllers).length === 0) return
  mutations.forEach(mutation => mutation.addedNodes.forEach(node => loadControllersIn(node)))
}).observe(document.documentElement, { childList: true, subtree: true })

export { application }
